<template>
  <confirm-dialog
    v-show="isShow"
    :data="dialogData"
    name="albumPickerModal"
    @confirm="handleConfirm"
  >
    <div class="album-picker-modal row">
      <div
        v-for="(imageUrl, index) in imageUrls"
        :key="index"
        class="position-relative ms-3 mt-3 photo added"
      >
        <span
          class="position-absolute album-remove pointer"
          @click="removeImage(index)"
        >&times;</span>
        <img :src="imageUrl" alt="" class="photo" />
      </div>
      <div class="upload-box ms-3 mt-3" @click="openImageSelector">
        <img src="/static/icons/button-add-cover.svg" alt="" />
      </div>
    </div>
    <div class="remake">ขนาดไฟล์สูงสุดคือ 1 MB</div>
    <input
      ref="album"
      type="file"
      accept="image/jpg, image/png, image/jpeg"
      class="input-file hidden"
      @change="albumChange($event.target.files)"
    />
  </confirm-dialog>
</template>

<script>
import { isEmpty, isNil } from "ramda";

export default {
  name: 'AlbumPickerModal',
  props: {
    title: {
      type: String,
      default: null
    },
    canEdit: {
      type: Boolean,
      default: true
    },
    isShow: {
      type: Boolean,
      default: false
    },
    album: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      imageFiles: [],
      imageUrls: []
    };
  },
  computed: {
    dialogData() {
      return {
        title: this.title,
        buttonCancel: "ยกเลิก",
        buttonSubmit: "บันทึก",
        disableSubmit: false,
        disableCancel: false,
        hideAction: false
      };
    },
  },
  watch: {
    album(newValue) {
      this.imageFiles = [ ...newValue ]
      this.imageUrls = this.albumToUrls(newValue);
    }
  },
  methods: {
    albumToUrls(album) {
      return !isEmpty(album)
        ? album.map(imageFile =>
            imageFile.url ? imageFile.url : URL.createObjectURL(imageFile)
          )
        : [];
    },
    albumChange(file){
      if (isNil(file[0])) {
        return;
      }

      const image = URL.createObjectURL(file[0]);

      this.imageFiles.push(file[0]);
      this.imageUrls.push(image);
    },
    removeImage(imagePosition) {
      this.imageFiles = this.imageFiles.filter(
        (image, index) => index !== imagePosition
      );
      this.imageUrls = this.imageUrls.filter(
        (url, index) => index !== imagePosition
      );
    },
    openImageSelector() {
      this.$refs.album.click();
    },
    handleConfirm(isConfirm) {
      if (!isConfirm) {
        this.imageUrls = this.albumToUrls(this.album);
        this.imageFiles = [ ...this.album ];
        this.$emit("cancel");
        return;
      }

      this.$emit("confirm", this.imageFiles);
    }
  }
};
</script>

<style lang="scss">
.album-picker-modal {
  border: 2px dashed #d8d6d9;
  line-height: 1.21;
  letter-spacing: normal;
  color: #8c8786;

  margin: 0 auto;
  overflow: auto;
  width: 550px;
  height: 400px;
}

.photo {
  width: 148px;
  height: 148px;
  border-radius: 16px;
  border: hidden;
  object-fit: cover;

  &.added {
    border: 1px solid #e0e0e0;
  }
}

.upload-box {
  width: 148px;
  height: 148px;
  border-radius: 16px;
  border: 2px dashed #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.setting-body {
  padding: 20px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.album-remove {
  top: 5px;
  right: 5px;
  background: #aaa;
  border-radius: 50%;
  border: 2px solid $white;
  width: 20px;
  height: 20px;
  padding: 3px;

  font-size: 16px;
  color: $white;
  line-height: 0.5;
}

.remake {
  font-size: 11px;
  font-weight: normal;
  line-height: 1.64;
  letter-spacing: -0.1px;
  color: #8c8786;
  margin-top: 16px;
  text-align: center;
}

.input-file {
  opacity: 0;
  position: absolute;
}
</style>
